import { Action, ACTION_TYPES } from './types';
import { AxiosError } from 'axios';
import { Dispatch } from 'redux';
import { getCases } from '../../api/casesListing';
import { Cases } from '../../api/casesListing/types';
import { casesFromApi } from './mapper';

export const start = (): Action => ({
  type: ACTION_TYPES.PENDING,
  payload: [null, null],
});

export const success = (payload: Cases): Action => ({
  type: ACTION_TYPES.SUCCESS,
  payload: [payload, null],
});

export const error = (payload: AxiosError): Action => ({
  type: ACTION_TYPES.ERROR,
  payload: [null, payload],
});

export const fetchCases = (status: string = 'active') => {
  return (dispatch: Dispatch<Action>) => {
    dispatch(start());
    getCases({ status: status })
      .then((res) => {
        dispatch(success(casesFromApi(res.data)));
      })
      .catch((err) => {
        dispatch(error(err));
      });
  };
};
